import { CircularProgress } from "@mui/material";

export const NowLoading = () => {
  return <CircularProgress />;
};
